import * as React from "react";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

export default function TimePickerValue() {
  const now = new Date();
  const formattedDateTime = now.toISOString(); // "2025-04-15T12:34:56.789Z"

  const [value, setValue] = React.useState(dayjs(formattedDateTime));

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["TimePicker", "TimePicker"]}>
        <TimePicker
          label="Select date"
          value={value}
          onChange={(newValue) => setValue(newValue)}
          slotProps={{
            textField: {
              variant: "outlined",
              size: "small",
              fullWidth: true,
              sx: {
                borderRadius: "25px",
                backgroundColor: "none",
                input: {
                  fontFamily: "ADLaM Display",
                  color: "#6b6b6b",
                },
              },
            },
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
